import { Box } from '@mui/material';
import { useTheme } from '@mui/styles';
import AboutSection from '../../components/home/about-section/about-section.component';
import Hero from '../../components/home/hero/hero.component';
import Openings from '../../components/home/openings-section/openings.component';
import { customTheme } from '../../shared/theme/theme';

const Homepage = () => {
  const theme = useTheme(customTheme);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.main,
      }}
    >
      <Hero />
      <AboutSection />
      <Openings />
    </Box>
  );
};

export default Homepage;
